import React, { useEffect, useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { toast } from 'react-toastify';
import { editModeOn, sanitizeInput, viewModeOn } from '../../utilFunctions';
import DocumentShow from '../../utilsComponent/documentShow';
import FileUpload from '../../utilsComponent/fileUpload';
import LoadingPage from '../../reusableComponents/loader/loadingPage';
import "../../dashboard/claimLitigation/litigation.scss"
import { createClaimLitigation, createLegalExpense, getLegalExpenses, getLitigationLists, fetchPotentialLitigationDetails, updatePotentialLitigation } from './litigationApi';
import AsteriskSymbol from '../../reusableComponents/AsteriskSymbol';
import TabComponent from '../../reusableComponents/tab/TabComponent';
import { functionalities, REGEX, potentialLitigationMaxLength } from '../../consts';
import NoDataFound from '../../utilsComponent/noDataFound';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'react-bootstrap';

const ClaimLitigation = (props) => {
    const { claimDetailCookie, roleDataCookie, getClaimDetails } = props;
    const [validtype] = useState(['image/jpeg', 'image/png', 'image/gif', 'image/jpg', 'image/bmp', 'image/webp', 'image/svg+xml', 'image/tiff', 'video/ogg', 'video/mp4', 'video/webm', 'video/quicktime', 'video/x-msvideo', 'video/x-ms-wmv', 'video/x-matroska', 'application/pdf', 'application/msword']);
    const [showAddLitigation, setShowAddLitigation] = useState(false);
    const [addedFiles, setAddedFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [remarks, setRemarks] = useState("");
    const [flagLitigation, setFlagLitigation] = useState(false);
    const [potentialLitigationRemarks, setPotentialLitigationRemarks] = useState("");
    const [remarksInModal, setRemarksInModal] = useState("");
    const [potentialLitigationModal, setPotentialLitigationModal] = useState(false);
    const [previousFlagLitigation, setPreviousFlagLitigation] = useState(false);
    const [potentialLitigationData, setPotentialLitigationData] = useState(null);
    const [litigationList, setLitigationList] = useState([]);
    const [disableLitigationBtn, setDisableLitigationBtn] = useState(false);
    const [showAddLegalExpense, setShowAddLegalExpense] = useState(false);
    const [legalExpenseAmount, setLegalExpenseAmount] = useState("");
    const [disableLegalExpenseBtn, setDisableLegalExpenseBtn] = useState(false);
    const [expenseList, setExpenseList] = useState();
    const [activeTab, setActiveTab] = useState(
        viewModeOn(functionalities.CLAIM_LITIGATION_SUBMISSION) ? 'litigation' :
            viewModeOn(functionalities.CLAIM_LEGAL_EXPENSES_PAGE) ? 'legalExpense' : ''
    ); // 'litigation' or 'legalExpense'

    useEffect(() => {
        if (viewModeOn(functionalities.CLAIM_LITIGATION_SUBMISSION)) {
            getLitigation();
        }
        if (viewModeOn(functionalities.CLAIM_LEGAL_EXPENSES_PAGE)) {
            getLegalExpense();
        }
    }, []);

    useEffect(() => {
        if (claimDetailCookie?.claimNo) {
            getPotentialLitigationDetails();
        }
    }, [claimDetailCookie?.claimNo]);

    const getLitigation = () => {
        setLoading(true);
        getLitigationLists(claimDetailCookie?.claimNo)
            .then(data => {
                setLitigationList(data);
            })
            .catch(error => {
                console.error("Error fetching litigation list:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const getLegalExpense = () => {
        setLoading(true);
        getLegalExpenses(claimDetailCookie?.claimNo)
            .then(data => {
                setExpenseList(data);
            })
            .catch(error => {
                console.error("Error fetching litigation list:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const createLitigation = () => {
        if (!remarks.trim()) {
            toast.error("Please Enter Remarks.");
            return;
        }
        setLoading(true);
        const litigationData = {
            claimId: claimDetailCookie?.claimNo,
            userId: roleDataCookie?.userID,
            documentId: addedFiles.map(list => list.id),
            remarks: remarks.trim()
        };
        createClaimLitigation(litigationData)
            .then(data => {
                toast.success(data.message);
                getClaimDetails(claimDetailCookie.claimNo);
                clearCreateLitigation(); // Reuse the clear function
                // Fetch the updated litigation list
                getLitigationLists(claimDetailCookie.claimNo)
                    .then(updatedList => {
                        setLitigationList(updatedList);
                    })
                    .catch(error => {
                        console.error("Error fetching updated litigation list:", error);
                    });
            })
            .catch(error => {
                console.error("Error creating litigation:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const clearCreateLitigation = () => {
        setRemarks(""); // Clear remarks here as well
        setAddedFiles([]);
        setDisableLitigationBtn(false);
        setShowAddLitigation(false);
    };

    const clearCreateLegalExpenses = () => {
        setRemarks("");
        setAddedFiles([]);
        setDisableLegalExpenseBtn(false);
        setShowAddLegalExpense(false);
        setLegalExpenseAmount("");
    };

    const handleAddLegalExpenseClick = () => {
        if (claimDetailCookie.assignedTo === "Unassigned" || !claimDetailCookie.assignedTo) {
            toast.error("Please Assign Claims Handler.");
            return;
        }
        setShowAddLegalExpense(true);
        setDisableLegalExpenseBtn(true);
    };

    const handleAddLitigationClick = () => {
        if (claimDetailCookie.assignedTo === "Unassigned" || !claimDetailCookie.assignedTo) {
            toast.error("Please Assign Claims Handler.");
            return;
        }
        setShowAddLitigation(true);
        setDisableLitigationBtn(true);
    };

    const handleCreateLegalExpense = () => {
        if (!legalExpenseAmount.trim() || !remarks.trim()) {
            toast.error(!legalExpenseAmount.trim() ? "Please Enter Legal Expense Amount." : "Please Enter Remarks.");
            return;
        }
        setLoading(true);
        const legalExpenses = {
            claimID: claimDetailCookie?.claimNo,
            amount: legalExpenseAmount.trim(),
            userId: roleDataCookie?.userID,
            documentId: addedFiles.map(list => list.id),
            remarks: remarks.trim()
        };

        createLegalExpense(legalExpenses)
            .then((response) => {
                toast.success(response.message || "This claim has been flagged for legal review");
                getClaimDetails(claimDetailCookie.claimNo);
                clearCreateLegalExpenses();
                getLegalExpenses(claimDetailCookie.claimNo)
                    .then(updatedList => {
                        setExpenseList(updatedList);
                    })
                    .catch(error => {
                        console.error("Error fetching updated legal expense list:", error);
                    });
            })
            .catch(error => {
                console.error("Error creating legal expense:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleTabClick = (tabName) => {
        setActiveTab(tabName);
    };
    const tabs = [
        { key: 'litigation', label: 'Claim Litigation', page: functionalities.CLAIM_LITIGATION_SUBMISSION },
        { key: 'legalExpense', label: 'Legal Expenses', page: functionalities.CLAIM_LEGAL_EXPENSES_PAGE },
    ];
    const filteredTabs = tabs.filter(tab => viewModeOn(tab.page));

    useEffect(() => {
        if (activeTab) {
            setRemarks("");
            setAddedFiles([]);
            setLegalExpenseAmount("")
            setShowAddLitigation(false);
            setShowAddLegalExpense(false);
            setDisableLitigationBtn(false);
            setDisableLegalExpenseBtn(false);
        }
    },[activeTab])

    const getPotentialLitigationDetails = () => {
        setLoading(true);
        fetchPotentialLitigationDetails (claimDetailCookie?.claimNo)
            .then(data => {
                setPotentialLitigationData(data);

                if (Array.isArray(data)) {
                    if (data.length > 0) {
                        setFlagLitigation(true);
                        setPreviousFlagLitigation(true)
                        setPotentialLitigationRemarks(data[0]?.remarks || "");
                    } else {
                        setFlagLitigation(false);
                        setPreviousFlagLitigation(false)
                        setPotentialLitigationRemarks("");
                    }
                } else if (typeof data === "string") {
                    setFlagLitigation(false);
                    setPreviousFlagLitigation(false)
                    setPotentialLitigationRemarks("");
                }
            })
            .catch(error => {
                console.error("Error fetching potential litigation details:", error);
                setFlagLitigation(false);
                setPotentialLitigationData("");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const flagPotentialLitigation = () => {
        const isFlagLitigationChecked = !flagLitigation;
        setPreviousFlagLitigation(flagLitigation);
        setFlagLitigation(isFlagLitigationChecked);
        setPotentialLitigationModal(true);
    };
    const submitPotentialLitigation = async() => {
        if (!remarksInModal) {
            toast.error("Please enter remarks")
            return;
        }
        setLoading(true)
        const response = await updatePotentialLitigation({
            claimNo: claimDetailCookie.claimNo,
            updatedBy: roleDataCookie?.userID,
            potentialLitigation: flagLitigation,
            remarks: remarksInModal

        })
        setLoading(false)
        toast.success(response)
        getPotentialLitigationDetails()
        setRemarksInModal("")
        setPotentialLitigationModal(false);
        };
    const handleModalClose = () => {
    setFlagLitigation(previousFlagLitigation);
    setPotentialLitigationModal(false);
    setRemarksInModal("");
    };

    return (
        <div className="inner-box2Field mt-3">
            <div>
                <div className="potential">
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="flagLitigation"
                            checked={flagLitigation}
                            onClick={flagPotentialLitigation}
                            readOnly
                        />
                        <label className="form-check-label" htmlFor="flagLitigation">
                            Flag a Potential Litigation
                        </label>
                    </div>
                {/* Display remarks below checkbox */}
                {previousFlagLitigation && potentialLitigationRemarks && (
                <div className='remarks-pt'>
                    <div>
                        <strong> Remarks: </strong>
                    </div>
                    <div>
                        <p className='remarks-text'>{potentialLitigationRemarks}</p>
                    </div>          
                </div>
                )}
                {potentialLitigationModal && (
                    <Modal show={potentialLitigationModal} isOpen={potentialLitigationModal} toggle={()=>{}} centered={true} backdrop={'static'}>
                    <ModalBody>
                        <div>
                            <label><h6>Remarks <AsteriskSymbol/></h6></label>
                        </div>
                        <div>
                            <textarea
                                className="remarksPotential"
                                placeholder="Please enter remarks"
                                value={remarksInModal}
                                onChange={(e) => {
                                    const potentialRemarks = e.target.value.replace(/[^a-zA-Z0-9 ]/g, "").slice(0, potentialLitigationMaxLength);
                                    setRemarksInModal(potentialRemarks);

                                }}>
                            </textarea>
                            <div className="remarks-text-info right">
                                <p>{remarksInModal.length}/{potentialLitigationMaxLength}</p>
                            </div>
                        </div>                        
                    </ModalBody>
                    <ModalFooter style={{ justifyContent: 'center' }}>
                        <Button color="secondary" style={{ borderColor: 'red', backgroundColor: 'transparent', color: 'red' }} onClick={handleModalClose}>Cancel</Button>
                        <Button color="primary" style={{ borderColor: 'green', backgroundColor: 'transparent', color: 'green' }} onClick={()=>submitPotentialLitigation()}>Submit</Button>
                    </ModalFooter>
                </Modal>
                )}
                </div>
            <TabComponent
                tabs={filteredTabs}
                activeTab={activeTab}
                handleTabClick={handleTabClick}
            />
        </div>
            {loading ? (
                <LoadingPage claimDone/>
            ) : (
                <div>
                    {activeTab === 'litigation' && (
                        <div id="bankDetailsPage" className='mt-4'>
                            <div className='d-flex align-items-end justify-content-end mb-3'>
                                {/* Only show the Add Litigation button if in edit mode and not already adding */}
                                {!showAddLitigation && editModeOn(functionalities.CLAIM_LITIGATION_SUBMISSION) && (
                                    <div className="requestCalc" onClick={handleAddLitigationClick}>
                                        Add Litigation
                                    </div>
                                )}
                            </div>

                            {/* Always show existing litigation list */}
                            {litigationList && litigationList.length > 0 ? (
                                litigationList.map((list, index) => (
                                    <Accordion className='mb-2' key={index}>
                                        <Accordion.Item className='mx-3 border_dark' eventKey={index + 1}>
                                            <Accordion.Header>
                                                <div className="gis-idCalc">Litigation-{index + 1}</div>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <div className="remarks-section">Remarks</div>
                                                <span>{list.remarks}</span>
                                                <div className="documents-section">Documents</div>
                                                <div className="row">
                                                    <div className="col-12">
                                                        <DocumentShow document={list.listOfDocDetails} />
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                ))
                            ) : (
                                // Only show "No data Found" if not currently adding a new litigation AND there are no existing records
                                !showAddLitigation && <NoDataFound text={"No data Found"} />
                            )}

                            {/* Show Add Litigation form */}
                            {showAddLitigation && (
                                <Accordion className='mb-2' defaultActiveKey={['0']}>
                                    <Accordion.Item className='mx-3 border_dark' eventKey="0">
                                        <Accordion.Header>
                                            <div className="gis-idCalc">Add Litigation</div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <div className="remarks-section">Remarks <AsteriskSymbol /></div>
                                            <textarea name="remarks" id="remarks" className='w-100 textarea' rows="5" maxLength={400} onChange={(e) => setRemarks(e.target.value)} value={remarks}></textarea>
                                            <div className="text-end small text-muted">{remarks.length}/400 characters</div>
                                            <FileUpload validtype={validtype} addedFiles={addedFiles} setAddedFiles={setAddedFiles} text={"Upload File"} module="litigation" roleDataCookie={roleDataCookie} doctypeName="litigation" tran_id={claimDetailCookie.claimNo} />
                                            <div className='button-group'>
                                                <div className="back_backAccess pointer" onClick={clearCreateLitigation}>Cancel</div>
                                                <div className="submit-2Access" onClick={createLitigation}>Submit</div>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            )}
                        </div>
                    )}

                    {activeTab === 'legalExpense' && (
                        <div className='mt-4'>
                            <div className='d-flex align-items-end justify-content-end mb-3'>
                                {/* Only show the Add Legal Expenses button if in edit mode and not already adding */}
                                {!showAddLegalExpense && editModeOn(functionalities.CLAIM_LEGAL_EXPENSES_PAGE) && (
                                    <div className="requestCalc" onClick={handleAddLegalExpenseClick}>
                                        Add Legal Expenses
                                    </div>
                                )}
                            </div>

                            {/* Always show existing legal expense list */}
                            {expenseList && expenseList.length > 0 ? (
                                expenseList.map((list, index) => (
                                    <Accordion className='mb-2' key={index}>
                                        <Accordion.Item className='mx-3 border_dark' eventKey={index + 1}>
                                            <Accordion.Header>
                                                <div className="gis-idCalc">Expense-{index + 1}</div>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <div className="accordion-item-container">
                                                    <div className="remarks-section">
                                                        <div className="label">Remarks</div> <span>{list.remarks}</span>
                                                    </div>
                                                    <div className="amount-documents-section">
                                                        <div className="amount-section">
                                                            <div className="label">Amount</div>
                                                            <span>₹</span>
                                                            <span>{list.amount}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="documents-section">Documents</div>
                                                    <div className="col-12">
                                                        <DocumentShow document={list.listOfDocDetails} />
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                ))
                            ) : (
                                // Only show "No data Found" if not currently adding a new legal expense AND there are no existing records
                                !showAddLegalExpense && <NoDataFound text={"No data Found"} />
                            )}

                            {/* Show Add Legal Expense form */}
                            {showAddLegalExpense && (
                                <Accordion className='mb-2' defaultActiveKey={['1']}>
                                    <Accordion.Item className='mx-3 border_dark' eventKey="1">
                                        <Accordion.Header>
                                            <div className="gis-idCalc"> Legal Expenses</div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <div className="remarks-section">Remarks <AsteriskSymbol /></div>
                                            <div className='text-remarks'><textarea name="remarks" id="remarks" className='w-100 textarea' rows="5" maxLength={400} onChange={(e) => setRemarks(e.target.value)} value={remarks}></textarea></div>
                                            <div className="text-end small text-muted">{remarks.length}/400 characters</div>
                                            <div className="mbb-3" >
                                                <div className="amount-section">
                                                    <div className='label'> Amount (₹) <AsteriskSymbol /> </div>
                                                    <input
                                                        className="form-control input"
                                                        placeholder='Enter Legal Expenses Amount'
                                                        id="legalExpenseAmount"
                                                        onChange={(e) => {
                                                            let inputValue = e.target.value;
                                                            inputValue = sanitizeInput(inputValue);
                                                            if ((REGEX.DECIMAL_NUMBER_REGEX.test(inputValue) || inputValue === "") && parseFloat(inputValue) > 0) {
                                                                setLegalExpenseAmount(inputValue);
                                                            } else if (inputValue === "") {
                                                                setLegalExpenseAmount("");
                                                            }
                                                        }}
                                                        value={legalExpenseAmount}
                                                    />
                                                </div>
                                                <FileUpload validtype={validtype} addedFiles={addedFiles} setAddedFiles={setAddedFiles} text={"Upload File"} module="legalExpense" roleDataCookie={roleDataCookie} doctypeName="legalExpense" tran_id={claimDetailCookie.claimNo} />
                                            </div>
                                            <div className='button-group'>
                                                <div className="back_backAccess pointer" onClick={clearCreateLegalExpenses}>Cancel</div>
                                                <div className="submit-2Access" onClick={handleCreateLegalExpense}>Submit</div>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            )}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default ClaimLitigation;